import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";

export const getSimCards = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/simcards?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const getSimcardsStatuses = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/simcards/statuses?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const getSimcardsSubstatuses = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/simcards/substatus?${makeQuery(filters)}`,
        headers: {
            ...headers,
                "X-Access-Token": token
            }
        });

export const getHistorySimcards = (iccid, token) =>
    axios({
        method: "get",
        url: `${api}/simcards/history/${iccid}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });
export const postBatchSimCard = (simcard, token) =>
    axios({
        method: "post",
        url: `${api}/simcards/batch?tz=${new Date().getTimezoneOffset()}`,
        headers: {
            "Content-Type": "multipart/form-data",
            "X-Access-Token": token
        },
        data: simcard
    });

export const postValidateBatchSimcards = (simcard, token) =>
    axios({
        method: "post",
        url: `${api}/simcards/batch/validations?tz=${new Date().getTimezoneOffset()}`,
        headers: {
            "Content-Type": "form-urlencoded",
            "X-Access-Token": token
        },
        data: simcard
    });

export const pingEvents = (event_id, token) =>
    axios({
        method: "get",
        url: `${api}/events/${event_id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const putSimcard = (simcard, token) =>
    axios({
        method: "put",
        url: `${api}/simcards/${simcard.iccid}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: simcard
    });

 export const patchSimcards = (simcardsArray, token) => {
        return axios({
            method: 'patch',
            url: `${api}/simcards/batch`,
            headers: {
                ...headers,
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            data: simcardsArray
        });
    };

export const postSimcardsStatuses = (status, token) =>
    axios({
        method: "post",
        url: `${api}/simcards/statuses`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: status
    });

export const putSimcardsStatuses = (status, token) =>
    axios({
        method: "put",
        url: `${api}/simcards/statuses/${status._id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: status
    });

export const getExportSimcardsService = (filters, token) => 
    axios({
        method: "get",
        url: `${api}/simcards/export?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        responseType: 'blob' // Importante para manejar archivos binarios
    });